<template>
  <div class="c-requestDetailContents">
    <div class="c-requestTitle">
      <h1>
        {{ requestDetail.title }}
      </h1>
      <div
        class="c-requestTitle-category"
        v-if="requestDetail.masterCategory.name"
      >
        <nuxt-link
          :to="{ path: `/requests/categories/${requestDetail.masterCategory.id}` }"
          v-if="!isConfirm"
        >
          {{ requestDetail.masterCategory.name }}の依頼
        </nuxt-link>
        <span v-else>{{ requestDetail.masterCategory.name }}の依頼</span>
      </div>
    </div>

    <div class="c-requestOutline">
      <outline-row
        icon="yen-circle"
        heading="予算"
        type="budget"
        :scrollToOffset="scrollToOffset"
        :contents="requestDetail.outline"
        :is-confirm="isConfirm"
      />

      <outline-row
        icon="calender"
        heading="残り時間"
        type="remaining_days"
        :scrollToOffset="scrollToOffset"
        :contents="requestDetail.outline"
      />

      <outline-row
        icon="calender"
        heading="納品希望日"
        type="delivery_dates"
        :scrollToOffset="scrollToOffset"
        :contents="requestDetail.outline"
      />

      <outline-row
        icon="users"
        heading="応募状況"
        type="application_status"
        :scrollToOffset="scrollToOffset"
        :contents="requestDetail.outline"
      />
    </div>

    <contents-menu-pc
      :position="position"
      :scroll-to-offset="scrollToOffset"
      :is-my-request="isMyRequest"
      v-if="isPC && !isConfirm"
    />

    <div class="c-requestContents">
      <div
        class="c-requestContentsSummary js-contentsMenu-summary"
        id="requestContentsSummary"
        v-if="requestDetail.summariesList.length"
      >
        <contents-summary :summary="requestDetail.summariesList" />
      </div>

      <div
        class="c-requestContentsDetail js-contentsMenu-detail"
        id="requestContentsDetail"
      >
        <heading-third
          heading="依頼内容の詳細"
          :border="true"
        />
        <contents-detail :detail="requestDetail.detailsList" />
      </div>

      <div
        class="c-requestContentsAddition"
        id="requestContentsAddition"
        v-if="!isConfirm"
        v-show="isShowAddition"
      >
        <heading-third
          heading="依頼内容の追記"
          :border="true"
        />
        <contents-addition :is-my-request="isMyRequest" />
      </div>

      <div
        class="c-requestContentsProposers"
        id="requestContentsProposers"
        v-if="!isConfirm"
      >
        <heading-third
          heading="提案者一覧"
          :border="true"
        />
        <contents-proposers :proposers="requestDetail.proposersList" />
      </div>

      <div
        class="c-requestContentsFaq js-contentsMenu-faq"
        id="requestContentsFaq"
        v-if="!isConfirm && (!isBusiness || isMyRequest)"
      >
        <heading-third
          heading="依頼内容についての質問"
          :border="true"
        />
        <contents-faq :is-my-request="isMyRequest" />
      </div>
    </div>
  </div>
</template>
<script>
// local components
import ContentsMenuPc from './components/ContentsMenuPc'
import HeadingThird from './components/HeadingThird'
import OutlineRow from './components/OutlineRow'
import ContentsSummary from './components/ContentsSummary'
import ContentsDetail from './components/ContentsDetail'
import ContentsAddition from './components/ContentsAddition'
import ContentsProposers from './components/ContentsProposers'
import ContentsFaq from './components/ContentsFaq'

// vuex
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'RequestDetailContents',
  components: {
    ContentsMenuPc,
    HeadingThird,
    OutlineRow,
    ContentsSummary,
    ContentsDetail,
    ContentsAddition,
    ContentsProposers,
    ContentsFaq
  },
  props: {
    position: {
      type: Number,
      default: 0
    },
    scrollToOffset: {
      type: Number,
      default: 0
    },
    requestDetail: {
      type: Object,
      default: () => {}
    },
    isConfirm: {
      type: Boolean,
      default: false
    },
    isMyRequest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    ...mapState('pages/requests/request', ['additionsList']),
    ...mapState('auth/user', ['isBusiness']),
    isShowAddition() {
      return (
        this.additionsList.length || (this.isMyRequest && !this.requestDetail.outline.isExpired)
      )
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  @include link-effect;
}

.c-requestTitle {
  h1 {
    font-weight: bold;
    font-size: 24px;
  }
}

.c-requestOutline {
  margin-top: 12px;
}

.c-requestContentsSummary {
  margin-top: 12px;
  padding: 24px 16px;
  border: 1px solid $color-gray-200;
  border-radius: 3px;
}

.c-requestContentsAddition {
  .c-requestHeadingThird {
    border-bottom: 0;
  }
}

.c-requestContentsAddition,
.c-requestContentsDetail,
.c-requestContentsProposers,
.c-requestContentsFaq {
  margin-top: 60px;
}

@media (max-width: breakpoint(Requests, M)) {
  .c-requestTitle {
    padding: 0 12px;

    h1 {
      margin-bottom: 4px;
      font-size: 18px;
      line-height: 1.4;
    }
  }

  .c-requestOutline {
    padding: 0 12px;
  }

  .c-requestContents {
    padding-top: 8px;
    border-top: 1px solid $color-gray-200;
    background: $color-gray-50;
  }

  .c-requestContentsSummary {
    margin-top: 0;
    padding: 0;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
    background: $color-white;
  }

  .c-requestContentsAddition,
  .c-requestContentsDetail,
  .c-requestContentsProposers,
  .c-requestContentsFaq {
    margin-top: 0;
    background: $color-white;
  }
}
</style>
